<template>
  <div class="mt-4">
    <el-table
      ref="multipleTable"
      :data="segmentData"
      style="width: 100%"
      :row-key="getRowKey"
      @selection-change="handleSelectionChange"
      header-row-class-name="thead-light table-th-color"
    >
      <el-table-column type="selection" width="100" :reserve-selection="true">
      </el-table-column>
      <el-table-column label="Name" width="250">
        <template slot-scope="scope">{{ scope.row.name }}</template>
      </el-table-column>
      <el-table-column :property="totalUsers" label="Total Users">
        <template slot-scope="scope">{{
          scope.row.audienceId.length
        }}</template>
      </el-table-column>
    </el-table>
    <div class="flex justify-end mt-4">
      <el-pagination
        background
        layout="prev, pager, next"
        @current-change="
          (value) => {
            currentPage = value;
            getAllSegments();
          }
        "
        :per-size="perPage"
        :total="totalUsers"
      >
      </el-pagination>
    </div>
    <div class="flex mt-6 justify-end gap-3">
      <div class="relative">
        <vs-button
          variant="primary"
          class="rounded-lg bg-primary border-0 text-white font-medium fsize14 py-3 w-full sm-fsize14"
          @click="segmentAdd"
        >
          Submit
        </vs-button>
      </div>
      <div class="relative">
        <button
          class="rounded-lg bg-gray border-0 text-white font-medium fsize14 py-3 px-8 w-full sm-fsize14"
          @click="closeSegments"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
</template>

<script>
const debounce = function debounce(func, wait = 800) {
  let debounceTimer;
  return function (...args) {
    if (debounceTimer) clearTimeout(debounceTimer);
    const context = this;
    debounceTimer = setTimeout(() => {
      func.apply(context, args);
    }, wait);
  };
};
export default {
  data() {
    return {
      multipleSelection: [],
      segmentData: [],
      handleCreateSegment: false,
    };
  },
  props: { search: { type: String, default: "" } },
  watch: {
    search: debounce(async function () {
      this.getAllSegments(this.search);
    }),
  },
  methods: {
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    getRowKey(row) {
      // console.log(row);
      return row._id;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    async getAllSegments(value) {
      try {
        let payload = {
          perPage: this.perPage,
          page: this.currentPage,
        };
        if (value) {
          Object.assign(payload, { name: value });
        }
        let data = await this.$store.dispatch("segment/getAllSegment", payload);
        this.segmentData = data.data.registeredUser;
        this.totalUsers = data.data.registeredUserLength;
        console.log(data);
      } catch (err) {
        console.log(err);
      }
    },
    segmentAdd() {
      this.$emit("segments", this.multipleSelection);
    },
    createSegment() {
      this.segmentAdd();
      this.$emit("handleCreateSegmentPopup");
    },
    closeSegments() {
      this.$emit("handleCreateSegmentPopup");
      this.multipleSelection = "";
      this.toggleSelection();
    },
  },
  async mounted() {
    this.getAllSegments();
    this.multipleSelection;
  },
};
</script>
